import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import InternetBankingActions from '../../actions/InternetBankingActions';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import AccountsStore from '../../stores/AccountsStore';
import RenameAccountsStore from '../../stores/RenameAccountsStore';
import RenameAccount from './RenameAccount';
import AccountTile from './AccountTile';
import StepHeader from '../../includes/StepHeader';
import StringConstants from '../../constants/StringConstants';
import { BioCatchContext } from '../BioCatchContext';
import { DIGITAL_SERVICING_CONTEXT } from '../../config/BioCatch';

class RenameAccountsLandingPage extends Component {
  constructor(props) {
    super(props);
    this.displayAccountList = this.displayAccountList.bind(this);
    this.handleAccountClick = this.handleAccountClick.bind(this);
    this.displayRenameAccountPage = this.displayRenameAccountPage.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.getBackText = this.getBackText.bind(this);
    this.getHeader = this.getHeader.bind(this);
    this.getSubHeader = this.getSubHeader.bind(this);
    this.state = {
      displayingRenameAccountPage: false,
      showModal: false,
      errorMessage: '',
      showLoader: false,
      error: false,
      selectedAccountID: null,
      isSingleAccount: false,
      accountsList: AccountsStore.getAll(),
    };
  }

  componentWillMount() {
    if (
      RenameAccountsStore.getBackPageReference() ===
      StringConstants.WEB_ACCOUNT_DETAILS
    ) {
      this.setState({
        displayingRenameAccountPage: true,
        selectedAccountID: RenameAccountsStore.getSelectedAccount(),
      });
    } else if (this.state.accountsList.length === 1) {
      this.setState({
        displayingRenameAccountPage: true,
        selectedAccountID: this.state.accountsList[0].id,
        isSingleAccount: true,
      });
    }
  }

  componentDidMount() {
    this.state.selectedAccountID === null &&
      sayLandingMessage(this.props.content.renameAccountsLandingPageHeader);
  }

  getBackText() {
    if (
      RenameAccountsStore.getBackPageReference() ===
      StringConstants.WEB_HOMEPAGE
    ) {
      if (this.state.displayingRenameAccountPage && !this.state.isSingleAccount)
        return this.props.content.back;
      return this.props.content.backToAccounts;
    } else {
      return this.props.content.back;
    }
  }

  getHeader() {
    return this.state.selectedAccountID === null
      ? this.props.content.renameAccountsLandingPageHeader
      : this.props.content.renameAccountHeader;
  }

  getSubHeader() {
    return this.state.selectedAccountID === null
      ? this.props.content.renameAccountsLandingPageSubHeader
      : this.props.content.renameAccountSubHeader;
  }

  displayAccountList() {
    let amountField = '';
    let accountListData = this.state.accountsList.map((account) => {
      const balances = account.balances[0];
      amountField = '';
      if (!_.isUndefined(balances)) {
        amountField = balances.amount;
      }
      return (
        <div
          key={account.id}
          className="c-account c-account--preferences"
          onClick={() => this.handleAccountClick(account.id)}
        >
          <AccountTile
            key={account.id}
            sortCode={account.sortCode}
            accountNumber={account.accountNumber}
            balance={amountField}
            displayName={account.displayName}
          />
        </div>
      );
    });
    return (
      <div>
        {accountListData}
        <button
          type="submit"
          className="c-btn c-btn--secondary"
          onClick={this.handleBackButton}
        >
          {this.getBackText()}
        </button>
      </div>
    );
  }

  displayRenameAccountPage() {
    return (
      <RenameAccount
        accountId={this.state.selectedAccountID}
        backText={this.getBackText()}
        handleBack={this.handleBackButton}
        content={this.props.content}
      />
    );
  }

  handleAccountClick(id) {
    this.setState({ displayingRenameAccountPage: true, selectedAccountID: id });
  }

  handleBackButton() {
    window.scroll(0, 0);

    if (
      this.getBackText() === this.props.content.backToAccounts ||
      RenameAccountsStore.getBackPageReference() ===
        StringConstants.WEB_ACCOUNT_DETAILS
    ) {
      InternetBankingActions.navigateToWebTask(
        RenameAccountsStore.getBackPageReference()
      );
    } else {
      sayLandingMessage(this.props.content.renameAccountsLandingPageHeader);
      this.setState({
        accountList: AccountsStore.getAll(),
        selectedAccountID: null,
        displayingRenameAccountPage: false,
      });
    }
  }

  render() {
    return (
      <BioCatchContext context={DIGITAL_SERVICING_CONTEXT}>
        <div className="page bow rename-accounts-page">
          <div id="site-main" className="container" role="main" tabIndex="-1">
            <div className="row">
              <div className="col-md1-18">
                {
                  <StepHeader
                    showheaderCrumbs
                    headerCrumbsMessage={this.getBackText()}
                    headerTitle={this.getHeader()}
                    onClick={this.handleBackButton}
                    headerSubtext={this.getSubHeader()}
                  />
                }
              </div>
            </div>
            {this.state.displayingRenameAccountPage
              ? this.displayRenameAccountPage()
              : this.displayAccountList()}
          </div>
        </div>
      </BioCatchContext>
    );
  }
}

RenameAccountsLandingPage.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(RenameAccountsLandingPage);
